import { connect } from 'react-redux';
import PatientHistory from './PatientHistory';
import { actions } from '../../../redux/modules/patients';
import { resetStore } from "../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.patients,
        me: state.login.me
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(PatientHistory);